import { Injectable, Inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from 'src/app.config';

@Injectable({
    providedIn: 'root',
})
export class NotesService {
    private dialogRef: MatDialogRef<any>;

    constructor(
        private dialog: MatDialog,
        private overlay: Overlay,
        private http: HttpClient,
        @Inject(APP_CONFIG) private config: AppConfig
    ) {}

    addNotes(quoteId: string, body: any): Observable<any> {
        const url = `${this.config.addNotesUrl}/${quoteId}/notes`;
        return this.http.post(url, body);
    }

    open(config: any): any {
        this.dialogRef = this.dialog.open(config.content, {
            data: config.data,
            maxWidth: '792px',
            panelClass: 'side-panel-dialog',
            scrollStrategy: this.overlay.scrollStrategies.noop(),
        });
        return this.dialogRef;
    }

    closeAll(): void {
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }
}
